module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-taranto.svg?0835e50401cd6c967f2478048fb9cd93";